import { Action } from "../../../actions/actions";
import { KeyActionTypes } from "../actions/actionTypes";
import _ from "lodash";

export interface keyRequest {
    id?: number;
    notes: string;
    reason: number;
    user: string;
    timestamp: string;
}

export function keyRequests(
    state: { results: keyRequest[]; count: number } = {
        results: [],
        count: 0
    },
    action: Action
) {
    switch (action.type) {
        case KeyActionTypes.GET_REQUESTS_SUCCESS:
            return action.payload.requests;
        default:
            return state;
    }
}

export function keyRequestLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case KeyActionTypes.GET_REQUESTS:
            return true;
        case KeyActionTypes.GET_REQUESTS_FAIL:
        case KeyActionTypes.GET_REQUESTS_SUCCESS:
            return false;

        default:
            return state;
    }
}
